import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getBaseUrl } from '@utils/general/getBaseUrl';
import { EXPNESE } from '@utils/constants/expense.constants';
import { LOCAL_STORAGE_KEYS } from '@utils/constants/local-storeage-keys.constants';

export const expneseApi = createApi({
    reducerPath: 'expneseApi',
    tagTypes: ['Expense'],
    baseQuery: fetchBaseQuery({
        baseUrl: getBaseUrl(),
         // credentials: 'include',
        prepareHeaders: (headers, { getState }) => {
            const currentState: any = getState();

            const token =
                currentState.auth.accessToken ||
                localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN_KEY);

            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        getAllExpenses: builder.query<
            [],
            {
                page?: number;
                limit?: number;
                username?: string;
                status?: string;
                from_date?: Date | string;
                to_date?: Date | string;
                expense_type_id?: string | number;
            }
        >({
            query: ({
                page = 1,
                limit = 10,
                username,
                status,
                from_date,
                to_date,
                expense_type_id,
            }) => {
                const queryParams = {
                    url: EXPNESE.GET_ALL,
                    params: { page, limit },
                };

                if (username) {
                    //@ts-ignore
                    queryParams.params.username = username;
                }

                if (status) {
                    //@ts-ignore
                    queryParams.params.status = status;
                }

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }
                if (expense_type_id) {
                    //@ts-ignore
                    queryParams.params.expense_type_id = expense_type_id;
                }

                return queryParams;
            },
        }),
        getExpense: builder.query<[], { id: string | number }>({
            query: ({ id }) => {
                return `${EXPNESE.GET_ONE}${id}`;
            },
        }),
        createExpense: builder.mutation({
            query: (body) => ({
                url: EXPNESE.CREATE,
                method: 'POST',
                body,
            }),
        }),
        updateExpense: builder.mutation({
            query: ({ id, body }) => ({
                url: `${EXPNESE.UPDATE}${id}`,
                method: 'PATCH',
                body,
            }),
        }),
        deleteExpense: builder.mutation({
            query: (id) => ({
                url: `${EXPNESE.DELETE}${id}`,
                method: 'DELETE',
            }),
        }),
        getExpenseTypes: builder.query<[], void>({
            query: () => ({
                url: EXPNESE.GET_TYPES,
            }),
            providesTags: ['Expense'],
        }),
    }),
    keepUnusedDataFor:0
});

export const {
    useGetAllExpensesQuery,
    useGetExpenseQuery,
    useGetExpenseTypesQuery, 
    useCreateExpenseMutation,
    useUpdateExpenseMutation,
    useDeleteExpenseMutation,
} = expneseApi;
